package com.mgacreative.hotel.feature.reservation.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Search
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.mgacreative.hotel.domain.model.Reservation
import com.mgacreative.hotel.shared.ui.designsystem.components.verticalScrollbar
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun ReservationListScreen(
    viewModel: NewReservationCalendarViewModel = koinViewModel(),
    onNavigate: (String) -> Unit = {}
) {
    val state by viewModel.state.collectAsState()
    
    var reservationToDelete by remember { mutableStateOf<Reservation?>(null) }
    var reservationToEdit by remember { mutableStateOf<Reservation?>(null) }

    Scaffold(
        bottomBar = { CalendarBottomNavBar(currentRoute = "ReservationListScreen", onNavigate = onNavigate) }
    ) { paddingValues ->
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(paddingValues)
                .background(Color(0xFFF8FAFC))
        ) {
            if (state.isLoading) {
                Box(modifier = Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                    CircularProgressIndicator(color = Color(0xFF2196F3))
                }
            } else {
                val listState = androidx.compose.foundation.lazy.rememberLazyListState()
                LazyColumn(
                    state = listState,
                    modifier = Modifier.fillMaxSize().verticalScrollbar(listState)
                ) {
                    item {
                        Text(
                            text = "Rezervasyon Listesi",
                            fontWeight = FontWeight.Bold,
                            fontSize = 18.sp,
                            modifier = Modifier.padding(16.dp),
                            color = Color(0xFF334155)
                        )
                        
                        // Advanced Search Section
                        Card(
                            modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 8.dp),
                            colors = CardDefaults.cardColors(containerColor = Color.White),
                            elevation = CardDefaults.cardElevation(2.dp)
                        ) {
                            Column(modifier = Modifier.padding(12.dp)) {
                                Text("Gelişmiş Arama", fontWeight = FontWeight.SemiBold, fontSize = 14.sp)
                                Spacer(modifier = Modifier.height(8.dp))
                                OutlinedTextField(
                                    value = state.searchQuery,
                                    onValueChange = { viewModel.updateSearchQuery(it) },
                                    modifier = Modifier.fillMaxWidth(),
                                    placeholder = { Text("Misafir Adı, Tarih, Acenta, Oda Tipi veya Oda No...") },
                                    leadingIcon = { Icon(Icons.Default.Search, contentDescription = "Ara") },
                                    singleLine = true,
                                    colors = OutlinedTextFieldDefaults.colors(
                                        focusedBorderColor = Color(0xFF2196F3),
                                        unfocusedBorderColor = Color(0xFFCBD5E1),
                                        focusedContainerColor = Color.White,
                                        unfocusedContainerColor = Color.White
                                    )
                                )
                            }
                        }
                        Spacer(modifier = Modifier.height(8.dp))
                    }

                    // LIST SECTION
                    items(state.filteredReservations) { res ->
                        ReservationListRow(
                            reservation = res,
                            onEditClick = { reservationToEdit = res },
                            onDeleteClick = { reservationToDelete = res }
                        )
                    }
                    
                    item {
                        Spacer(modifier = Modifier.height(80.dp))
                    }
                }
            }
        }
    }

    if (reservationToEdit != null) {
        EditReservationDialog(
            reservation = reservationToEdit!!,
            onDismiss = { reservationToEdit = null },
            onSave = { updatedReservation ->
                viewModel.updateReservation(updatedReservation)
                reservationToEdit = null
            }
        )
    }

    if (reservationToDelete != null) {
        AlertDialog(
            onDismissRequest = { reservationToDelete = null },
            title = { Text("Rezervasyonu Sil") },
            text = { Text("Bu rezervasyonu silmek istediğinize emin misiniz? Bu işlem geri alınamaz.") },
            confirmButton = {
                Button(
                    onClick = {
                        reservationToDelete?.id?.let { viewModel.deleteReservation(it) }
                        reservationToDelete = null
                    },
                    colors = ButtonDefaults.buttonColors(containerColor = Color(0xFFEF4444))
                ) {
                    Text("Sil")
                }
            },
            dismissButton = {
                TextButton(onClick = { reservationToDelete = null }) {
                    Text("İptal")
                }
            }
        )
    }
}
